import { Fragment, useEffect } from "react";
import { useAppSelector } from "../../redux/hooks";
import { useLazyQuery } from "@apollo/client";
import { GET_MISSED_ACKNOWLEDGMENTS_REPORT } from "../../graphQL/queries";
import { buildMissedAcknowledgments, getMissingAcknowledgmentsQueryDateRange, IMissedAcknowledgmentPeriod } from '../../helpers/managerHelper';
import { displayDate } from "../../helpers/renderHelper";
import { map, isEmpty } from 'lodash';
import LoadingSpinner from "../common/LoadingSpinner";
import { AppMessages } from "../../strings"
import { ACKNOWLEDGEMENT_STATUS } from "../../constants";

const ManagerMissedAcknowledgments = () => {

	const currentUser = useAppSelector(state => state.appState.currentUser)
	const currentSelectedGroup = useAppSelector(state => state.nav.currentSelectedGroup)
	const currentOrganization = useAppSelector(state => state.appState.currentOrganization);

	const [getMissedAcknowledgmentReport, getMissedAcknowledgmentReportResponses ] = useLazyQuery(GET_MISSED_ACKNOWLEDGMENTS_REPORT);

	useEffect(()=>{
		if (currentSelectedGroup && currentUser) {
			if (currentSelectedGroup?.groupID !== -1 && currentUser?.isInDriverRole === false) {
				const { startDate, endDate } = getMissingAcknowledgmentsQueryDateRange(currentOrganization);
				getMissedAcknowledgmentReport({
					variables: {
						groupID: currentSelectedGroup?.groupID ?? -1,
						startDate,
						endDate,
					}
				})
			}
		}
	}, [currentSelectedGroup, currentUser, currentOrganization, getMissedAcknowledgmentReport])

	const acknowledmentReport = buildMissedAcknowledgments(currentOrganization, getMissedAcknowledgmentReportResponses.data?.missingAcknowledgmentsReport)

	function renderMissedAcknowledgmentPeriod(period: IMissedAcknowledgmentPeriod, index: number) {
		
		return (
			<div key={`ack-period-${index}`} className="card tile" >
				<div className="app-surface-panel" style={{margin:"0.35rem", borderRadius:'0.25rem' }}>
					<div className="row g-0" >
						<div className="col-12 fs-5 fw-bold mb-sm-0" style={{marginLeft:20, justifyContent:'center', marginTop: "0.5rem"}}>
							{`${displayDate(period.startDate)} - ${displayDate(period.endDate)} ${period.isCurrent ? '(Current)' : ''}`}
						</div>
						<hr className="hr app-divider" style={{marginTop: "0.5rem", marginBottom: 10, opacity:1 }} />
					</div>
					{  isEmpty(period.users) ?
						<div className="row g-0" style={{height:'3rem', display:'flex' }}>
							<div style={{marginLeft:20, marginTop:5}}>
								{AppMessages.noMissedAcknowledgments}
							</div>
						</div>
						:
						map(period.users,(user, index) => {
							const isLast = index === (period.users.length - 1)
							return (
								<div key={`user-key-312-${index}`}>
									<div className="row g-0" style={{minHeight: !isEmpty(user.acknowledgmentHistory) ? '4rem' : '3rem'}}>
										<div className="col-12 fs-6 mt-sm-0 g-0" style={{marginLeft:20, marginBottom: 10, display:'flex', alignSelf:'center'}}>{`${user.firstName} ${user.lastName}`}</div>
										<div className="col-12 fs-6 mt-sm-0 g-0" style={{marginTop: 0, paddingTop: 0, marginLeft:20, marginBottom:5, display:'flex', flexWrap:'wrap'}}>
											{ map(user.acknowledgmentHistory, (h, index) => {
												switch (h.status) {
													case ACKNOWLEDGEMENT_STATUS.ACKNOWLEDGED:
														return <i key={`ack-${index}`} className="fa-solid fa-square-check icn-green fa-xl" style={{marginRight:5, marginBottom:5}} />
													case ACKNOWLEDGEMENT_STATUS.NOT_ACKNOWLEDGED:
														return <i key={`ack-${index}`} className="fa-solid fa-square-xmark icn-red fa-xl" style={{marginRight:5, marginBottom:5 }} />
													case ACKNOWLEDGEMENT_STATUS.ACK_NOT_REQUIRED:
														return <i key={`ack-${index}`} className="fa-regular fa-square-minus icn-green fa-xl" style={{marginRight:5, marginBottom:5 }} />
													case ACKNOWLEDGEMENT_STATUS.NO_DATA:
													default:
														return <i key={`ack-${index}`} className="fa-regular fa-square-minus icn-gray fa-xl" style={{marginRight:5, marginBottom:5 }} />
												}
											})}
										</div>
									</div>
									{!isLast && <hr className="hr app-divider" style={{ marginBottom: 5,  opacity:1 }} />}
								</div>
							)
						})
					
					}
				</div>
			</div>
		)
	}

	function renderLegend() {
		const gap = {marginRight: 4};
		const itemGap = {marginRight: 12};
		return (
			<div className="small mb-2" style={{fontSize: '0.8rem', color: 'var(--bs-secondary)', display: 'flex', flexWrap: 'wrap', alignItems: 'center'}}>
				<i className="fa-solid fa-square-check icn-green" style={gap} /><span style={itemGap}>Acknowledged</span>
				<i className="fa-solid fa-square-xmark icn-red" style={gap} /><span style={itemGap}>Missed</span>
				<i className="fa-regular fa-square-minus icn-green" style={gap} /><span style={itemGap}>Not required</span>
				<i className="fa-regular fa-square-minus icn-gray" style={gap} /><span>No data</span>
			</div>
		);
	}

	return (
		<Fragment>
			{ getMissedAcknowledgmentReportResponses.loading && <LoadingSpinner title={'Acknowledgments'}/> }
			<div className="container app-page-text" style={{marginTop:5}}>
				{currentSelectedGroup?.name &&
					<div className="fw-bold mb-1" style={{fontSize:'1rem'}}>
						{currentSelectedGroup.name}
					</div>
				}
				{renderLegend()}
				{
					map(acknowledmentReport, (period, index) => renderMissedAcknowledgmentPeriod(period, index) )
				}
			</div>
		</Fragment>
	)
}

export default ManagerMissedAcknowledgments;